import { Badge, Card, Col, Empty, Pagination, Row, Spin } from 'antd';
import dayjs from 'dayjs';
import { useGetAttentionDocumentList } from 'features/document-report/use-cases/get-attention-documents';
import FileViewer from 'features/new-clients/components/clients-details/file-viewer';
import { useUserContext } from 'features/users';
import { Fragment, useEffect, useState } from 'react';
import { formatUtcToLocal } from 'routes/utils';

export const AttentionDocumentView = ({
  setAddCommentsModal,
  setCommentsInfo,
  year,
  month,
  getDocumentsCount,
  searchName,
}: // selectedValue,
any) => {
  const { user } = useUserContext();
  const activetabValue: any = localStorage.getItem('activeTab');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9); // Number of items per page
  const {
    data: state,
    isLoading,
    refetch: attentionrefetch,
  } = useGetAttentionDocumentList({
    PageIndex: currentPage,
    RecordPerPage: itemsPerPage,
    CompanyId: user?.CompanyId,
    Year: year,
    Month: month,
    Name: searchName,
    ClientId: user?.Id,
  } as any);
  const handleCardClick = (item: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(item);
  };
  const handleFileViewerClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevents the card click from firing
  };
  const totalRecords = state?.rc?.[0]?.totalRecords || 0;
  const paginatedData = state?.rc || [];
  const totalPages = Math.ceil(totalRecords / itemsPerPage);
  useEffect(() => {
    if (activetabValue == 4) {
      attentionrefetch();
      // inital()
      getDocumentsCount();
    }
  }, [activetabValue, currentPage]);

  return (
    <Fragment>
      <Row gutter={[16, 16]}>
        {isLoading ? (
          // Show loading spinner when fetching data
          <Col span={24} className='flex justify-center items-center'>
            <Spin size='large' />
          </Col>
        ) : paginatedData && paginatedData?.length > 0 ? (
          paginatedData.map((item: any, index: number) => (
            <Col
              key={item.id || index}
              xxl={6}
              xl={8}
              lg={8}
              md={12}
              sm={24}
              className='self-stretch'
            >
              <Card
                onClick={() => handleCardClick(item)}
                className='h-full bg-[#F6F7F9] lgl_crd border-0 flex flex-col justify-between'
                bodyStyle={{
                  padding: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                }}
              >
                <div className='flex gap-2'>
                  <div>
                    <div className='bg-white p-2 rounded-xl relative'>
                      {' '}
                      {/* <FileText stroke='#8B91B1' strokeWidth={1} size={62} /> */}
                      <figure
                        className='mediafolder'
                        onClick={handleFileViewerClick}
                      >
                        <FileViewer documentPath={item.documentPath} />
                      </figure>
                    </div>
                  </div>

                  <div className='flex flex-col grow'>
                    <div className='flex justify-between'>
                      <p className='font-bold'>{item?.categoryName}</p>
                      <div className='flex justify-between mb-2'>
                        {item?.documentStatus && (
                          <Badge className='bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded leading-5'>
                            {item?.documentStatus}
                          </Badge>
                        )}
                      </div>
                    </div>
                    <p>{item?.documentName}</p>
                    <span>
                      {item?.totalComments
                        ? `${item?.totalComments} Comments`
                        : '0 Comments'}
                    </span>
                    <p className='text-xs text-gray-500'>
                      Last Updated:{' '}
                      {/* {dayjs(item?.lastUpdatedDate).format('DD-MM-YYYY')} */}
                      {formatUtcToLocal(
                        dayjs(item?.lastUpdatedDate).format('DD-MMM-YYYY'),
                      )}
                    </p>
                  </div>
                </div>
              </Card>
            </Col>
          ))
        ) : (
          <Col span={24}>
            <Empty description='No Attention Documents Found' />
          </Col>
        )}
      </Row>
      {totalPages > 1 && (
        <Pagination
          current={currentPage}
          pageSize={itemsPerPage}
          total={totalRecords}
          onChange={(page) => setCurrentPage(page)}
          showSizeChanger={false} // Hides the page size dropdown
        />
      )}
    </Fragment>
  );
};
